import React from 'react';
import RadioGroup from './radio_group';
import style from './style.module.scss';
import { InstallmentsFormGroupProps, PaymentStyle, PaymentMethod } from '../types';

export const InstallmentsFormGroup: React.FC<InstallmentsFormGroupProps> = ({
  values,
  setFieldValue,
  formattedDiscountPrice,
  formattedInstallmentPrice,
  formattedInstallmentsDates
}) => {
  return (
    <div className="form-group">
      <fieldset className="inputs">
        <legend className={style.noMargin}>
          <span>Payment</span>
        </legend>
        <RadioGroup
          name="installmentTypeId"
          optionsArray={[
            {
              displayName: `Pay full ${formattedDiscountPrice} today`,
              value: PaymentStyle.FULLPAYMENT
            },
            {
              displayName: 'Pay in installments',
              value: PaymentStyle.INSTALLMENTS,
              children: (
                <div className={style.installments}>
                  <small>
                    <p>Four interest-free payments. No fees or credit check.</p>
                    <ul>
                      {formattedInstallmentsDates.map((date, index) => (
                        <li key={index}>
                          Due <strong>{date}</strong> {formattedInstallmentPrice}
                        </li>
                      ))}
                    </ul>
                  </small>
                </div>
              )
            }
          ]}
          selected={values.paymentStyle}
          onChange={(newValue) => {
            setFieldValue('paymentStyle', newValue);
            if (newValue !== PaymentStyle.FULLPAYMENT) {
              setFieldValue('paymentMethod', PaymentMethod.STRIPE);
            }
          }}
        />
      </fieldset>
    </div>
  );
};

export default InstallmentsFormGroup;
